module.exports = __webpack_public_path__ + "img/audit.806f941d.svg";